import type {
  PackCode,
  ProjectStatus,
  RequestType,
  Typology,
} from '@bcl/shared';

export const requestTypeLabels: Record<RequestType, string> = {
  etude_raccordement: 'Étude de raccordement fibre',
  point_raccordement: 'Demande de point de raccordement (PAR / PBO)',
  travaux_fibre: 'Travaux fibre / génie civil',
  previsite_technique: 'Pré-visite technique (technicien)',
  reparation_sav: 'Réparation / SAV',
  devis_travaux_divers: 'Demande de devis travaux divers',
  securisation_fibre: 'Sécurisation installation fibre',
  enfouissement_cables: 'Enfouissement de câbles',
};

export const typologyLabels: Record<Typology, string> = {
  maison_individuelle: 'Maison individuelle',
  appartement: 'Appartement',
  logement_collectif: 'Logement collectif',
  locaux_pro: 'Locaux professionnels',
  batiment_a_renover: 'Bâtiment à rénover',
  lotissement: 'Lotissement',
  promoteur: 'Promoteur',
  amenageur: 'Aménageur',
  entreprise: 'Entreprise',
  villa: 'Villa',
  immeuble_collectif: 'Immeuble collectif',
  residence: 'Résidence',
  commerce: 'Commerce',
  batiment_public: 'Bâtiment public',
  zone_activite: "Zone d'activité",
};

export const packLabels: Record<PackCode, string> = {
  serenite_fibre: 'Sérénité Fibre — Maison individuelle',
  essentiel_fibre: 'Essentiel Fibre — Construction en collectif',
  confort_fibre: 'Confort Fibre — Premium collectif',
  remise_en_conformite_sav: 'Remise en conformité / SAV',
};

export const statusLabels: Record<ProjectStatus, string> = {
  compte_cree: 'Compte créé',
  projet_renseigne: 'Projet renseigné',
  demande_qualifiee: 'Demande qualifiée',
  documents_deposes: 'Documents déposés',
  en_verification_bcl: 'En attente vérification BCL',
  dossier_valide: 'Dossier validé',
  paiement_valide: 'Paiement validé',
  pris_en_charge: 'Pris en charge',
  analyse_en_cours: 'Analyse en cours',
  previsite_planifiee: 'Pré-visite planifiée',
  intervention_realisee: 'Intervention réalisée',
  compte_rendu_disponible: 'Compte rendu disponible',
  travaux_en_cours: 'Travaux en cours',
  termine: 'Terminé',
  cloture: 'Clôturé',
};
